import { createSelector } from 'reselect'

export const getPageMetaTags = createSelector(
  (state) => state && state.common && Array.isArray(state.common.pageMetaTags) ? state.common.pageMetaTags : [],
  (pageMetaTags) => pageMetaTags
)
